import { HStack } from '@chakra-ui/react';

import { Footer } from './footer';
import { Logo } from './logo';
import { Navbar } from './navbar';

export interface ContentProps {
  isLargeScreen: boolean;
  onNavigate?: () => void;
  scrolled?: boolean;
  /** When true (drawer use case) skip the Logo and use large nav size */
  largeNav?: boolean;
}

export function Content({
  isLargeScreen,
  onNavigate,
  scrolled,
  largeNav = false,
}: ContentProps) {
  if (isLargeScreen) {
    return (
      <>
        <Logo scrolled={scrolled} />
        <HStack spacing="24px">
          <Navbar isLargeScreen onNavigate={onNavigate} />
          <Footer isLargeScreen />
        </HStack>
      </>
    );
  }

  return (
    <>
      {!largeNav && <Logo scrolled={scrolled} />}
      <Navbar
        isLargeScreen={false}
        size={largeNav ? 'large' : 'default'}
        onNavigate={onNavigate}
      />
      <Footer isLargeScreen={false} />
    </>
  );
}
